/** 单次实验的完整 JSON 导出（事件日志 + 元信息，AC-F021-02）。 */
import type { ExperimentConfig } from '../core/config-schema';
import type { SimEvent } from '../core/engine/events';
import type { MetricsSummary, SeriesPoint } from '../core/metrics/collector';
import type { MetaEntry } from '../core/engine/simulation';
import type { StrategyParams } from '../strategy/strategy-api';

export interface ExperimentJson {
  readonly config: ExperimentConfig;
  readonly strategyId: string;
  readonly params: StrategyParams;
  readonly summary: MetricsSummary;
  readonly eventLog: readonly SimEvent[];
  readonly metaLog: readonly MetaEntry[];
  readonly metricsSeries: readonly SeriesPoint[];
}

export function experimentToJson(payload: ExperimentJson): string {
  return JSON.stringify(payload, null, 2);
}
